const colors = {
  // Core brand colors
  deepBlue0: "#171F31",
  deepBlue1: "#252A3F",
  deepBlue2: "#33374B",
  deepBlue3: "#43475B",
  deepBlue4: "#00081C",
  lightBlue: "#228cbd",
  lightYellow: "80FF80",

  // Shades of gray as transparent whites
  white0: "rgba(255, 255, 255, 0.1)",
  white1: "rgba(255, 255, 255, 0.2)",
  white2: "rgba(255, 255, 255, 0.3)",
  white3: "rgba(255, 255, 255, 0.4)",
  white4: "rgba(255, 255, 255, 0.5)",
  white5: "rgba(255, 255, 255, 0.6)",
  white6: "rgba(255, 255, 255, 0.7)",
  white7: "rgba(255, 255, 255, 0.8)",
  white8: "rgba(255, 255, 255, 0.9)",
  white9: "#ffffff",

  // Accent colors for highlighting data
  accentYellow: "#FFC200",
  accentPlum: "rgb(183, 76, 164)",
  accentCoral: "rgb(234, 107, 114)"
};

export default colors;
